import { render, staticRenderFns } from "./PlatformClients.vue?vue&type=template&id=466985b4&"
import script from "./PlatformClients.vue?vue&type=script&lang=js&"
export * from "./PlatformClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports